import { Route } from '@angular/router';
import { SmsAccessGuard as InboxSmsAccessGuard } from '../../ui/src/guards/sms-access.guard';
import { InboxHomeComponent } from '../../ui/src/pages/inbox-home/inbox-home.component';
import { ChatComponent } from './wrappers/chat.component';
import { CreateContactComponent } from './wrappers/create-contact.component';
import { NewMessageComponent } from './wrappers/new-message.component';
import { SettingsComponent } from './settings/settings.component';
import { InboxContainerComponent } from './inbox-container/inbox-container.component';
import { SettingsAccessGuard } from '../../ui/src/guards/settings-access.guard';
import { AIChatInboxOverlayComponent } from './inbox-ai/inbox-ai-overlay/inbox-ai-overlay.component';
import { NewWebchatComponent } from './settings/webchat-configuration/new-webchat/new-webchat.component';
import { ShowWebchatComponent } from './settings/webchat-configuration/show-webchat/show-webchat.component';
import { EditWebchatComponent } from './settings/webchat-configuration/edit-webchat/edit-webchat.component';

export const INBOX_TEMPLATE_MESSAGE_ROUTES: Route[] = [
  {
    path: 'message-templates',
    loadComponent: () => import('../../inbox/index').then((m) => m.ListMessageTemplatesComponent),
    data: {
      pageOptions: { ['displayFullScreen']: true, ['hideNavToolbar']: true },
    },
  },
  {
    path: 'message-templates/create',
    loadComponent: () =>
      import(
        '../../inbox/src/settings/message-templates/create-message-template/create-message-template.component'
      ).then((m) => m.CreateMessageTemplateComponent),
    data: {
      pageOptions: { ['displayFullScreen']: true, ['hideNavToolbar']: true },
    },
  },
  {
    path: 'message-templates/:templateId',
    loadComponent: () =>
      import('../../inbox/src/settings/message-templates/edit-message-template/edit-message-template.component').then(
        (m) => m.EditMessageTemplateComponent,
      ),
    data: {
      pageOptions: { ['displayFullScreen']: true, ['hideNavToolbar']: true },
    },
  },
];

export const INBOX_ROUTES: Route[] = [
  {
    path: '',
    component: InboxContainerComponent,
    children: [
      {
        path: '',
        component: InboxHomeComponent,
      },
      {
        path: 'views/:viewId/conversations',
        component: InboxHomeComponent,
      },
      {
        path: 'conversations/:id',
        component: ChatComponent,
      },
      {
        path: 'create-contact',
        component: CreateContactComponent,
        canActivate: [InboxSmsAccessGuard],
      },
      {
        path: 'new-message',
        component: NewMessageComponent,
        canActivate: [InboxSmsAccessGuard],
      },
    ],
  },
  {
    path: 'settings',
    canActivate: [SettingsAccessGuard],
    children: [
      {
        path: '',
        component: SettingsComponent,
      },
      ...INBOX_TEMPLATE_MESSAGE_ROUTES,
    ],
  },
  {
    path: 'ai',
    component: AIChatInboxOverlayComponent,
  },
  {
    path: 'widgets',
    children: [
      {
        path: 'new',
        component: NewWebchatComponent,
        canDeactivate: [(c: NewWebchatComponent) => c.canDeactivate()],
      },
      {
        path: ':widgetId',
        component: ShowWebchatComponent,
      },
      {
        path: ':widgetId/edit',
        component: EditWebchatComponent,
        canDeactivate: [(c: EditWebchatComponent) => c.canDeactivate()],
      },
    ],
  },
];
